import { EventHandlerConfig } from "@/widgetLibrary/interface"

export const TEXT_EVENT_HANDLER_CONFIG: EventHandlerConfig = {
  events: [],
  methods: ["setValue", "clearValue"],
}
